import React from 'react';

const COUNT_ABBRS = ['', 'K', 'M', 'B', 'T', 'P', 'E', 'Z', 'Y'];
export const formatCount = (count, withAbbr = false, decimals = 4) => {
    const i = (count === 0) ? count : Math.floor(Math.log(count) / Math.log(1000));
    let result = Math.floor((count / Math.pow(1000, i)) * Math.pow(10, decimals)) / Math.pow(10, decimals);
    if (withAbbr) {
        result += `${COUNT_ABBRS[i]}`;
    }
    return result;
};

export const splitDecimals = (value) => {
    return value.toString().split('.');
};

export const commaSeparator = (value) => {
    return value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const noExponent = (value) => {
    const data = String(value).split(/[eE]/);

    if (data.length === 1) {
        return data[0];
    }

    let z = '';
    const sign = this < 0 ? '-' : '';
    const str = data[0].replace('.', '');
    let mag = Number(data[1]) + 1;

    if (mag < 0) {
        z = sign + '0.';
        while (mag++) {
            z += '0';
        }
        return z + str.replace(/^\\-/, '');
    }

    mag -= str.length;

    while (mag--) {
        z += '0';
    }
    return str + z;
};

export const bigIntStringify = (value) => {
    const updatedValue = value.split('');

    if (updatedValue && updatedValue.length) {
        if (updatedValue[updatedValue.length - 1] !== '0') {
            updatedValue[updatedValue.length - 1] = '0';
        }
        if (updatedValue[updatedValue.length - 2] !== '0') {
            updatedValue[updatedValue.length - 2] = '0';
        }
        if (updatedValue[updatedValue.length - 3] !== '0') {
            updatedValue[updatedValue.length - 3] = '0';
        }
        if (updatedValue[updatedValue.length - 4] !== '0') {
            updatedValue[updatedValue.length - 4] = '0';
        }
    }

    return updatedValue.join('');
};

export const bigFloatStringify = (number) => {
    const value = String(number);
    let updatedValue = null;
    if (value.length && value.length === 4) {
        updatedValue = String(value) + '0000000000000000';
    } else if (value.length && value.length === 3) {
        updatedValue = String(value) + '00000000000000000';
    } else if (value.length && value.length === 1) {
        updatedValue = String(value) + '.000000000000000000';
    } else {
        updatedValue = number.toFixed(18);
        updatedValue = bigIntStringify(updatedValue);
    }

    return updatedValue;
};

export const formatDuration = (duration) => {
    const parts = duration && duration.toString().split('.');

    if (parts.length === 2) {
        const distance = parts[0] * 1000;

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);
        const time = {
            days,
            hours,
            minutes,
            seconds,
        };

        return (
            <>
                {time && time.days ? time.days + ':' : ''}
                {time && time.hours ? time.hours + ':'
                    : time && time.days && !time.hours
                        ? '00:'
                        : ''}
                {time && time.minutes ? time.minutes + ''
                    : time && time.hours && !time.minutes
                        ? '00'
                        : ''}
                {time && time.days > 0
                    ? null
                    : time && time.minutes && time.seconds
                        ? `:${time.seconds > 9 ? time.seconds : `0${time.seconds}`}`
                        : time && time.minutes && !time.seconds
                            ? ':00'
                            : time && !time.minutes && time.seconds
                                ? `00:${time.seconds > 9 ? time.seconds : `0${time.seconds}`}`
                                : '00'}
            </>
        );
    }

    const distance = duration * 1000;
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);
    const time = {
        days,
        hours,
        minutes,
        seconds,
    };

    return (
        <>
            {time && time.days ? time.days + ':' : ''}
            {time && time.hours ? time.hours + ':'
                : time && time.days && !time.hours
                    ? '00:'
                    : ''}
            {time && time.minutes ? time.minutes + ''
                : time && time.hours && !time.minutes
                    ? '00'
                    : ''}
            {time && time.days > 0
                ? null
                : time && time.minutes && time.seconds
                    ? `:${time.seconds > 9 ? time.seconds : `0${time.seconds}`}`
                    : time && time.minutes && !time.seconds
                        ? ':00'
                        : time && !time.minutes && time.seconds
                            ? `00:${time.seconds > 9 ? time.seconds : `0${time.seconds}`}`
                            : '00'}
        </>
    );
};
